/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



//START Popups, um Luftbilder zu vergrößern
document.addEventListener('DOMContentLoaded', function () {
  const productPopupLinks = document.getElementsByClassName('product-gallery__popup-link');
  const lightBoxPopupWrapper = document.getElementById('product-gallery__popup_wrapper');
  const lightBoxPopup = document.getElementById('product-gallery__popup');
  const lightBoxPopupContent = document.getElementById('product-gallery__popup-content');
  const lightBoxPopupCloser = document.getElementById('product-gallery__popup-closer');

  // Funktion zum Schließen des Popups
  function closePopup() {
    lightBoxPopupWrapper.classList.remove('show');
  }

  // Event-Listener für den "X"-Button
  if (lightBoxPopupCloser) {
    lightBoxPopupCloser.addEventListener('click', closePopup);
  }

  // Event-Listener für einen Klick auf den Hintergrund oder das Bild
  lightBoxPopupWrapper.addEventListener('click', function (event) {
    // Popup schließen, wenn auf den Hintergrund oder das Bild geklickt wird
    closePopup();
  });

  // Event-Listener für die Produktbilder (zum Öffnen des Popups)
  if (productPopupLinks.length > 0 && lightBoxPopup) {
    for (var i = 0; i < productPopupLinks.length; i++) {
      productPopupLinks[i].addEventListener('click', function (event) {
        const image = this.getElementsByClassName('product-gallery__image')[0];

        lightBoxPopupWrapper.classList.add('show');

        if (image) {
          lightBoxPopupContent.textContent = '';
          lightBoxPopupContent.appendChild(image.cloneNode(false));
        }
      });
    }
  }

  // Setze den maxZoom-Wert je nach Bildschirmgröße
  let maxZoom = window.innerWidth >= 1280 ? 2 : 4;

  panzoom(lightBoxPopupContent, {
    maxZoom: maxZoom,
    minZoom: 1,
  });

  const popups = document.querySelectorAll('.popup');

  if (popups.length > 0) {
    [...popups].map(function (popup) {
      const label = popup.querySelector('.popup__label');
      const wrapper = label.nextElementSibling;

      wrapper.querySelector('.popup__closer').addEventListener('click', function () {
        wrapper.classList.remove('active');
      });

      wrapper.querySelector('.popup__title_close').addEventListener('click', function () {
        wrapper.classList.remove('active');
      });

      wrapper.querySelector('.popup__title_close2').addEventListener('click', function () {
        wrapper.classList.remove('active');
      });

      label.addEventListener('click', function (e) {
        if (wrapper) {
          if (wrapper.classList.contains('active')) {
            wrapper.classList.remove('active');
            document.body.style.overflow = 'auto';
          } else {
            wrapper.classList.add('active');
            document.body.style.overflow = 'hidden';
          }
        }
      });
    });
  }
});
//ENDE




//START Funktion, um Währungszeichen optimiert anzeigen zu lassen
document.addEventListener('hulkapp_rendered', function () {
  const hulkapp_selects = document.querySelectorAll('select.hulkapps_option_child');

  for (i = 0; i < hulkapp_selects.length; i++) {
    hulkapp_selects[i].firstChild.innerHTML = ' ';
  }

  for (i = 0; i < hulkapp_selects.length; i++) {
    for (m = 0; m < hulkapp_selects[i].children.length; m++) {
      const option = hulkapp_selects[i].children[m];

      option.innerHTML = option.innerHTML.replace('+', '');
      option.innerHTML = option.innerHTML.replace('€', '€ ');
    }
  }
});



//START Funktion, um während des Ladestatus ein Overlay zu zeigen.
var loader123 = document.querySelector(".loader123");

if (typeof window !== 'undefined') {
  loader123.classList.add("show");

  setTimeout(function() {
    loader123.classList.add("hide");
    setTimeout(function() {
      loader123.classList.remove("show", "hide");
    }, 500); 
  }, 500); 
}
//END


//START return and back buttons
$(document).ready(function () {
  $('.return-button').hide();

  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) return $('.return-button').fadeIn();

    $('.return-button').fadeOut();
  });

  $('.return-button').click(function () {
    $('body,html').animate(
      {
        scrollTop: 0,
      },
      800
    );
  });

  $('.return-button2').click(function () {
    window.history.back();
  });
  
    $('.zurueck_luftbild').click(function () {
    window.history.back();
  });
  
});
//END


//START *<!-- jQuery für Bildwechsel -->*/
    $(function () {
        var imagesCompareElement = $('.js-img-compare').imagesCompare();
        var imagesCompare = imagesCompareElement.data('imagesCompare');
        var events = imagesCompare.events();
        imagesCompare.on(events.changed, function (event) {
            console.log(events.changed);
            console.log(event.ratio);
            if (event.ratio < 0.4) {
                console.log('We see more than half of the back image');
            }
            if (event.ratio > 0.6) {
                console.log('We see more than half of the front image');
            }
            if (event.ratio <= 0) {
                console.log('We see completely back image');
            }
            if (event.ratio >= 1) {
                console.log('We see completely front image');
            }
        });
        $('.js-front-btn').on('click', function (event) {
            event.preventDefault();
            imagesCompare.setValue(1, true);
        });
        $('.js-back-btn').on('click', function (event) {
            event.preventDefault();
            imagesCompare.setValue(0, true);
        });
        $('.js-toggle-btn').on('click', function (event) {
            event.preventDefault();
            if (imagesCompare.getValue() >= 0 && imagesCompare.getValue() < 1) {
                imagesCompare.setValue(1, true);
            } else {
                imagesCompare.setValue(0, true);
            }
        });
    });
//END

//*folgender Code wird verwendet, um auf der Startseite den Button "Luftbildsuche" mit einer Lupe zu versehen.
    let searchButton = document.querySelector('a.button.buttoncustom1[href="https://www.digitale-luftbilder.de/pages/search-results-page?tab=products&sort_by=created&page=1"]');
    
    if (searchButton) {
      let svgNS = "http://www.w3.org/2000/svg";
      let svg = document.createElementNS(svgNS, "svg");
      svg.setAttributeNS(null, "viewBox", "0 0 32 32");
      svg.setAttributeNS(null, "width", "32px");
      svg.setAttributeNS(null, "height", "32px");
      
     
      let line = document.createElementNS(svgNS, "line");
      line.setAttributeNS(null, "x1", "20");
      line.setAttributeNS(null, "y1", "20");
      line.setAttributeNS(null, "x2", "28");
      line.setAttributeNS(null, "y2", "28");
      line.setAttributeNS(null, "stroke", "#fff");
      line.setAttributeNS(null, "stroke-width", "2");
      svg.appendChild(line);
      
      let path = document.createElementNS(svgNS, "path");
      path.setAttributeNS(null, "d", "M 16 8 A 8 8 0 0 1 24 16 A 8 8 0 0 1 16 24 A 8 8 0 0 1 8 16 A 8 8 0 0 1 16 8 z M 16 10 A 6 6 0 0 0 10 16 A 6 6 0 0 0 16 22 A 6 6 0 0 0 22 16 A 6 6 0 0 0 16 10 z");
      path.setAttributeNS(null, "fill", "#fff");
      svg.appendChild(path);
      
      let icon = document.createElement("img");
      icon.setAttribute("src", "data:image/svg+xml;base64," + btoa(new XMLSerializer().serializeToString(svg)));
      icon.style.width = "32px";
      icon.style.height = "32px";
      
      let span = document.createElement("span");
      span.style.display = "inline-block";
      span.style.width = "32px";
      span.style.height = "32px";
      span.style.verticalAlign = "middle";
      span.style.marginLeft = "8px";
      span.appendChild(icon);
      
      searchButton.appendChild(span);
    }



//START wenn über die E-Mail-Adresse oder Telefonnummer gehovert wird erscheint eine Infobox
//Mail
function showpopup01(message) {
  const overlay01 = document.createElement('div');
  overlay01.style.position = 'fixed';
  overlay01.style.top = '0';
  overlay01.style.left = '0';
  overlay01.style.width = '100%';
  overlay01.style.height = '100%';
  overlay01.style.background = 'rgba(0, 0, 0, 0.5)';
  overlay01.style.zIndex = '9998';

  const popup01 = document.createElement('div');
  popup01.style.position = 'fixed';
  popup01.style.top = '50%';
  popup01.style.left = '50%';
  popup01.style.transform = 'translate(-50%, -50%)';
  popup01.style.zIndex = '9999';
  popup01.style.padding = '20px';
  popup01.style.borderRadius = '6px';
  popup01.style.border = '7px solid #3d81b3';
  popup01.style.background = '#fff';
  popup01.style.textAlign = 'center';

  const text = document.createElement('p');
  text.textContent = message;
  popup01.appendChild(text);

  const closeButton01 = document.createElement('button');
  closeButton01.textContent = 'Schließen';
  closeButton01.style.marginTop = '10px';
  closeButton01.style.padding = '2px 20px 2px 20px';
  closeButton01.style.borderRadius = '3px';
  closeButton01.style.cursor = 'pointer';
  closeButton01.style.background = 'rgb(245,245,245)';
  closeButton01.addEventListener('click', () => {
    document.body.removeChild(overlay01);
  });

    overlay01.addEventListener('click', (event) => {
    if (event.target === overlay01) {
      document.body.removeChild(overlay01);
    }
  });
  
  closeButton01.addEventListener('mouseenter', () => {
    closeButton01.style.background = 'rgb(238,238,238)';
  });
  closeButton01.addEventListener('mouseleave', () => {
    closeButton01.style.background = 'rgb(245,245,245)';
  });
  popup01.appendChild(closeButton01);

  overlay01.appendChild(popup01);
  document.body.appendChild(overlay01);
}


function copyToClipboard(event) {
  event.preventDefault();

  const email = event.target.textContent.trim();
  navigator.clipboard.writeText(email);

  showpopup01('E-Mail-Adresse erfolgreich in den Zwischenspeicher kopiert');
}

const mail01Div = document.querySelector('.mail01');
mail01Div.addEventListener('click', (event) => {
  copyToClipboard(event);
});

//Phone
const phone01 = document.querySelector('.phone01');

phone01.addEventListener('click', () => {
  const overlay01 = document.createElement('div');
  overlay01.style.position = 'fixed';
  overlay01.style.top = '0';
  overlay01.style.left = '0';
  overlay01.style.width = '100%';
  overlay01.style.height = '100%';
  overlay01.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
  overlay01.style.zIndex = '9999';

const toolphone = document.createElement('div');
toolphone.innerHTML = 'Gerne können Sie uns Montag bis Samstag von 8:00 - 20:00 Uhr erreichen.<br>Wir freuen uns auf Ihren Anruf!<br><br>Oliver Acker<br>digitale-luftbilder.de<br>Tel: 0175 / 24 24 204';
toolphone.style.position = 'fixed';
toolphone.style.top = '50%';
toolphone.style.left = '50%';
toolphone.style.transform = 'translate(-50%, -50%)';
toolphone.style.padding = '40px 20px 40px 20px';
toolphone.style.backgroundColor = '#fff';
toolphone.style.color = '#333';
toolphone.style.lineHeight = '1.5';
toolphone.style.textAlign = 'center';
toolphone.style.borderRadius = '6px';
toolphone.style.border = '7px solid #3d81b3';
toolphone.style.zIndex = '10000';


  const closeButton01 = document.createElement('button');
  closeButton01.textContent = 'x';
  closeButton01.style.position = 'absolute';
  closeButton01.style.top = '5px';
  closeButton01.style.right = '10px';
  closeButton01.style.backgroundColor = 'transparent';
  closeButton01.style.color = '#333';
  closeButton01.style.border = 'none';
  closeButton01.style.fontSize = '24px';
  closeButton01.style.cursor = 'pointer';

  toolphone.appendChild(closeButton01);
  overlay01.appendChild(toolphone);
  document.body.appendChild(overlay01);

  closeButton01.addEventListener('click', () => {
    document.body.removeChild(overlay01);
  });

  overlay01.addEventListener('click', (event) => {
    if (event.target === overlay01) {
      document.body.removeChild(overlay01);
    }
  });
  
});
//END



//START Materialien vergrößern (innerhalb der Toggle / Popups)
const bilder = document.querySelectorAll(".vergrößerbar");

bilder.forEach((bild) => {
  bild.addEventListener("click", () => {
    const großesBild = document.createElement("img");
    großesBild.src = bild.src;
    großesBild.alt = bild.alt;
    großesBild.style.maxWidth = "100%";
    großesBild.style.maxHeight = "100%";
    großesBild.style.objectFit = "contain";

    const overlay03 = document.createElement("div");
    overlay03.style.position = "fixed";
    overlay03.style.top = 0;
    overlay03.style.left = 0;
    overlay03.style.width = "100%";
    overlay03.style.height = "100%";
    overlay03.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
    overlay03.style.display = "flex";
    overlay03.style.justifyContent = "center";
    overlay03.style.alignItems = "center";
    overlay03.style.zIndex = "9999"; 

    const fadeTime = 250; 

    // Ein- und Ausblenden des Bildes
    großesBild.style.opacity = 0;
    overlay03.style.opacity = 0;
    overlay03.appendChild(großesBild);
    document.body.appendChild(overlay03);
    const fadeIn = () => {
      let opacity = 0;
      const timer = setInterval(() => {
        if (opacity >= 1) {
          clearInterval(timer);
        }
        großesBild.style.opacity = opacity;
        overlay03.style.opacity = opacity;
        opacity += 0.1;
      }, fadeTime / 10);
    };
    fadeIn();

    const schließenButton = document.createElement("button");
    schließenButton.textContent = "X";
    schließenButton.style.position = "absolute";
    schließenButton.style.top = "10px";
    schließenButton.style.right = "10px";
    schließenButton.style.fontSize = "2rem";
    schließenButton.style.border = "none";
    schließenButton.style.backgroundColor = "transparent";
    schließenButton.style.color = "#fff";
    schließenButton.style.cursor = "pointer";
    overlay03.appendChild(schließenButton);

    // Funktion zum Schließen des vergrößerten Bildes
    const schließen = () => {
      // Ausblenden des Bildes
      let opacity = 1;
      const timer = setInterval(() => {
        if (opacity <= 0) {
          clearInterval(timer);
          document.body.removeChild(overlay03);
        }
        großesBild.style.opacity = opacity;
        overlay03.style.opacity = opacity;
        opacity -= 0.1;
      }, fadeTime / 10);
    };

    overlay03.addEventListener("click", (e) => {
      if (e.target !== großesBild) {
        schließen();
      }
    });

    schließenButton.addEventListener("click", schließen);
    großesBild.addEventListener("click", schließen);
  });
});
//END


//START Inhalt ändern von Button, wenn Bildschirmauflösung unter 640 Pixel
  let luftbild3 = document.getElementsByClassName("zurueck_luftbild");

function checkResolution3() {
    if (window.matchMedia("(max-width: 640px)").matches) {
        for (let i = 0; i < luftbild3.length; i++) {
            luftbild3[i].innerHTML = "❮❮";
        }
    } else {
        for (let i = 0; i < luftbild3.length; i++) {
            luftbild3[i].innerHTML = "❮❮   zurück";
        }
    }
}
checkResolution3();
window.addEventListener("resize", checkResolution3);
//END


//START Button Luftbildnext
  let luftbild2 = document.getElementsByClassName("next_luftbild");

function checkResolution2() {
    if (window.matchMedia("(max-width: 640px)").matches) {
        for (let i = 0; i < luftbild2.length; i++) {
            luftbild2[i].innerHTML = "❯❯";
        }
    } else {
        for (let i = 0; i < luftbild2.length; i++) {
            luftbild2[i].innerHTML = "nächstes Luftbild ❯❯";
        }
    }
}
checkResolution2();
window.addEventListener("resize", checkResolution2);
//END



//START Button Luftbildzufall
  let luftbild = document.getElementsByClassName("zufall_luftbild");

function checkResolution() {
    if (window.matchMedia("(max-width: 640px)").matches) {
        for (let i = 0; i < luftbild.length; i++) {
            luftbild[i].innerHTML = "Zufall";
        }
    } else {
        for (let i = 0; i < luftbild.length; i++) {
            luftbild[i].innerHTML = "zufälliges Luftbild";
        }
    }
}
checkResolution();
window.addEventListener("resize", checkResolution);
//END


//START für Hulkapp-Options: Sucht nach den Wörtern Material, Abmessung und Größe. Danach werden restliche (unnötige Zeichen entfernt, damit für User übersichtlicher
window.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var optionNames = document.querySelectorAll('.hulkapps_option_name');
    for (var i = 0; i < optionNames.length; i++) {
      var optionName = optionNames[i];
      if (optionName.textContent.includes('Material')) {
        optionName.textContent = 'Material';
      }
    }
  }, 1000);
});

window.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var optionNames2 = document.querySelectorAll('.hulkapps_option_name');
    for (var i = 0; i < optionNames2.length; i++) {
      var optionName2 = optionNames2[i];
      if (optionName2.textContent.includes('Abmessung')) {
        optionName2.textContent = 'Abmessung';
      }
    }
  }, 1000);
});

window.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var optionNames3 = document.querySelectorAll('.hulkapps_option_name');
    for (var i = 0; i < optionNames3.length; i++) {
      var optionName3 = optionNames3[i];
      if (optionName3.textContent.includes('Größe')) {
        optionName3.textContent = 'Größe';
      }
    }
  }, 1000);
});
//END





// START Balken unter Überschrift (inkl. Schreibmaschinen- /Tipp-Animation)
/* const title01 = document.querySelector('.heading.h1');
const text01 = 'digitale-luftbilder.de';

if (title01) {
  /*
  if (title01.textContent.trim() === text01 || title01.textContent.trim() === "") {
    const textLength = text01.length;
    let counter = 0;
    title01.textContent = "";

    const interval = setInterval(function () {
      if (counter >= textLength) {
        clearInterval(interval);
      } else {
        title01.textContent += text01[counter];
        counter++;
      }
    }, 100);
  }
  */

  /*function startBarAnimation() {
    title01.classList.add('animate-bar');
    title01.style.setProperty('--bar-opacity', '0');
    setTimeout(() => {
      title01.style.setProperty('--bar-opacity', '1');
    }, 50);
  }

  setTimeout(() => {
    startBarAnimation();
  }, 3000);
}*/
// END Balken unter Überschrift (inkl. Tipp-Animation)




// START topButton scroll up to start
var topButton = document.getElementById("top-button");

function styleButton() {
  topButton.style.position = "fixed";
  topButton.style.bottom = "30px";
  topButton.style.right = "30px";
  topButton.style.width = "50px";
  topButton.style.height = "50px";
  topButton.style.backgroundColor = "rgba(85, 85, 85, 0.4)";
  topButton.style.color = "#fff";
  topButton.style.border = "none";
  topButton.style.borderRadius = "50%";
  topButton.style.boxShadow = "0 5px 8px rgba(0, 0, 0, 0.2)";
  topButton.style.cursor = "pointer";
  topButton.style.opacity = "0";
  topButton.style.visibility = "hidden";
  
  topButton.style.transition = "background-color 0.6s ease, transform 0.6s ease, box-shadow 0.6s ease, opacity 0.6s ease, visibility 0.6s ease";

  topButton.style.fontSize = "20px";
  topButton.style.display = "flex";
  topButton.style.alignItems = "center";
  topButton.style.justifyContent = "center";
  topButton.style.zIndex = "1000";
  
  topButton.innerHTML = "&#x203A;";
  topButton.style.transform = "rotate(-90deg)";

  topButton.addEventListener('mouseover', function () {
    topButton.style.backgroundColor = "rgba(68, 68, 68, 0.8)";
    topButton.style.transform = "rotate(-90deg) scale(1.1)";
    topButton.style.boxShadow = "0 12px 20px rgba(0, 0, 0, 0.4)";
  });

  topButton.addEventListener('mouseout', function () {
    topButton.style.backgroundColor = "rgba(85, 85, 85, 0.7)";
    topButton.style.transform = "rotate(-90deg) scale(1)";
    topButton.style.boxShadow = "0 8px 15px rgba(0, 0, 0, 0.3)";
  });

  topButton.animate([
    { transform: 'rotate(-90deg) scale(1)', boxShadow: '0 8px 15px rgba(0, 0, 0, 0.3)' },
    { transform: 'rotate(-90deg) scale(1.05)', boxShadow: '0 10px 20px rgba(0, 0, 0, 0.35)' },
    { transform: 'rotate(-90deg) scale(1)', boxShadow: '0 8px 15px rgba(0, 0, 0, 0.3)' }
  ], {
    duration: 2000,
    iterations: Infinity
  });
}
// END topButton scroll up to start


// Funktion, um den Button anzuzeigen/verstecken
function showButton() {
  if (window.pageYOffset > 350) {
    topButton.style.opacity = "1";
    topButton.style.visibility = "visible";
  } else {
    topButton.style.opacity = "0";
    topButton.style.visibility = "hidden";
  }
}

// Scrollen nach oben
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// Events hinzufügen
window.addEventListener("scroll", showButton);
topButton.addEventListener("click", scrollToTop);

// Stile anwenden, wenn das Skript geladen wird
styleButton();




// Suchergebnisseite auf 95% breite anzeigen lassen, sofern URL bestimmten String enthält

if (window.innerWidth >= 1000) {
  if (window.location.href.includes("https://www.digitale-luftbilder.de/pages/search-results-page")) {
    const pageContent = document.querySelector(".page__content.rte");
    pageContent.style.maxWidth = "95%";
  }
}

//in der Collection Page die Collection Luftbild zu LUFTBILDER ändern

document.addEventListener('DOMContentLoaded', function() {
  const collectionItems = document.querySelectorAll('.collection-block-item__title');
    collectionItems.forEach(item => {
    if (item.textContent === 'Luftbild') {
      item.textContent = 'LUFTBILDER';
    }
  });
});

// Titel der Ergebnisseite der Produktsuche ändern (Überschrift wird geändert)
if (window.location.href === "https://www.digitale-luftbilder.de/pages/search-results-page?q=Produktsuche") {
  const title = document.querySelector("h1.page__title");
  title.innerText = "Hier können Sie nach Bücher,  Kalender, Puzzles und vieles mehr suchen";
}


// Für Produktkategorie Postkarten: Wenn man auf Bilder-Thumbnails klickt, wird automatisch die Variante (div block-swatch) ausgewählt.

  //im ersten Schritt den ersten Div .product-gallery__thumbnail entfernen, da die Kaiserburg doppelt angezeigt wird
document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.includes("https://www.digitale-luftbilder.de/products/die-nurnberg-postkarten")) {
    var firstThumbnailElement = document.querySelector(".product-gallery__thumbnail");
    if (firstThumbnailElement) {
      firstThumbnailElement.parentNode.removeChild(firstThumbnailElement);
    }
  }
});


   //nun sind Anzahl der .product-gallery__thumbnail und der block-swatches identisch. somit kann folgender code ausgeführt werden.
document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.includes("https://www.digitale-luftbilder.de/products/die-nurnberg-postkarten")) {
    var thumbnailElements = document.querySelectorAll(".product-gallery__thumbnail-list .product-gallery__thumbnail");
    var swatchElements = document.querySelectorAll(".block-swatch-list .block-swatch");
    thumbnailElements.forEach(function(element, index) {
      element.addEventListener("click", function() {
        if (index < swatchElements.length) {
          swatchElements[index].querySelector("input").click();
        }
      });
    });
  }
});





//Versandkosten für Postkarten ändern
if(window.location.href === "https://www.digitale-luftbilder.de/products/die-nurnberg-postkarten"){
  var versandkosten = document.querySelector(".Versandkosten");
  if(versandkosten !== null){
    versandkosten.innerHTML = "Versandkosten 2,90 €";
  }
  var freihaus = document.querySelector(".freihaus");
  if(freihaus !== null){
    freihaus.innerHTML = "(frei Haus ab 11 Postkarten)";
  }
}




//Phonesymbol zum anrufen, wenn Bildschrimbreite unter 640 pixel ist
  var phoneIcon = document.querySelector('.header__phone-icon');
  var phoneNumber = '01752424204';
  var phoneNumberLink = 'tel:' + phoneNumber;
  phoneIcon.parentElement.setAttribute('href', phoneNumberLink);




//START Paymentbuttons unterhalb des Checkoutbutton von der Größe anpassen (ging leider nicht mit CSS)
document.addEventListener("DOMContentLoaded", function() {
    
    var container = document.querySelector(".payment01");
    var image = document.querySelector(".paymentpic01");

    var maxWidth = container.offsetWidth * 0.50;
    image.style.maxWidth = maxWidth + "px";

    image.style.marginTop = "10px";

    var checkoutButton = document.querySelector(".checkout-button");
    var paymentButtons = document.querySelectorAll(".payment-buttons button");

    var checkoutWidth = checkoutButton.offsetWidth;
    paymentButtons.forEach(function(button) {
        button.style.width = checkoutWidth + "px"; 
        button.style.height = "80px"; 
    });
});
//END Paymentbuttons unterhalb...





//START Animation der Search-Bar
const searchInput = document.querySelector('.search-bar__input');

const placeholders = [
  "...oder geben Sie einfach den gewünschten Ort oder einen Straßennamen ein...",
  "...oder suchen Sie nach einem Luftbild-Buch, Puzzle, Fotodruck, Leinwand?",
  "...Sie haben nicht das gefunden, was Sie gesucht haben? Gerne können Sie Kontakt mit uns aufnehmen. Wir freuen uns auf Ihren Anruf / E-Mail"
];

function typeText(inputElement, text, delay, callback) {
  inputElement.setAttribute('placeholder', '');

  let i = 0;
  function type() {
    if (i < text.length) {
      inputElement.setAttribute('placeholder', inputElement.getAttribute('placeholder') + text.charAt(i));
      i++;
      setTimeout(type, delay);
    } else if (callback) {
      callback(); 
    }
  }
  type();
}

function deleteText(inputElement, delay, callback) {
  let text = inputElement.getAttribute('placeholder');
  let i = text.length;

  function erase() {
    if (i >= 0) {
      inputElement.setAttribute('placeholder', text.substring(0, i));
      i--;
      setTimeout(erase, delay);
    } else if (callback) {
      callback();
    }
  }
  erase();
}

function startAnimation() {
  let index = 0;
  function cyclePlaceholders() {
    typeText(searchInput, placeholders[index], 50, function() {
      setTimeout(function() {
        deleteText(searchInput, 30, function() {
          index = (index + 1) % placeholders.length;
          cyclePlaceholders();
        });
      }, 4000);
    });
  }
  cyclePlaceholders();
}
setTimeout(startAnimation, 10000);
searchInput.setAttribute('placeholder', placeholders[0]);
//END




//START Name des Browsertabs ändern
const titles = [
  "Kostenlose Lieferung ab 50€ Bestellwert",
  "Qualität aus Überzeugung",
  "Luftbilder aus der Region"
];

let currentTitleIndex = 0;

function changeTitle() {
  document.title = titles[currentTitleIndex];
    currentTitleIndex = (currentTitleIndex + 1) % titles.length; 
    setTimeout(changeTitle, 6000); 
}
setTimeout(changeTitle, 6000);
//END






//START Christmas, Winter, Schneeflocken, Snowflakes
// NEU snow overlay
function startSnow() {
  const c = document.createElement('canvas');
  c.id = 'xmas-snow';
  c.style.position = 'fixed';
  c.style.top = 0;
  c.style.left = 0;
  c.style.pointerEvents = 'none';
  c.style.width = '100%';
  c.style.height = '100%';
  c.style.zIndex = 9999;
  document.body.appendChild(c);

  const ctx = c.getContext('2d');
  let W = c.width = window.innerWidth;
  let H = c.height = window.innerHeight;

  let numFlakes = 80;
  if (W <= 768) numFlakes = 20;
  else if (W <= 1024) numFlakes = 40;

  const flakes = Array.from({length: numFlakes}, () => ({
    x: Math.random() * W,
    y: Math.random() * H,
    r: 2 + Math.random() * 2,
    s: 0.2 + Math.random() * 0.7,
    rot: Math.random() * Math.PI * 2,
    spin: (Math.random() - 0.5) * 0.02,

    // NEU: Grundgeschwindigkeit horizontal
    vxBase: (Math.random() - 0.5) * 0.01, 

    // NEU: Schwingungsphase
    driftPhase: Math.random() * Math.PI * 2,

    arms: Array.from({length:6}, () => ({
      length: 5 + Math.random() * 3
    }))
  }));

  function draw() {
    ctx.clearRect(0, 0, W, H);

    for (const f of flakes) {
      f.rot += f.spin;

      ctx.save();
      ctx.translate(f.x, f.y);
      ctx.rotate(f.rot);
      ctx.strokeStyle = '#fff';
      ctx.lineWidth = 1;

      for (let i = 0; i < 6; i++) {
        const arm = f.arms[i];
        ctx.save();
        ctx.rotate(i * Math.PI / 3);
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(0, arm.length);
        ctx.stroke();
        ctx.restore();
      }

      ctx.restore();

      // NEU: sanfte horizontale Drift (Schwingen)
      f.driftPhase += 0.01;
      const drift = Math.sin(f.driftPhase) * 0.2;

      // NEU: horizontale Geschwindigkeit = Basis + Schwingen
      f.x += f.vxBase + drift;

      // Vertikal
      f.y += f.s;

      if (f.y > H) {
        f.y = -10;
        f.x = Math.random() * W;
      }

      if (f.x < -20) f.x = W + 20;
      if (f.x > W + 20) f.x = -20;
    }

    requestAnimationFrame(draw);
  }

  window.addEventListener('resize', () => {
    W = c.width = window.innerWidth;
    H = c.height = window.innerHeight;
  });

  draw();
}

startSnow();

//END


//Anfragefeld für Luftbildkunden validieren

//END

//Checkout button umbenennen

//Luftbildergebnisse auf Desktop verändern bei click auf Button

//kleine Paralaxen

//fullscreen Bild

//START Bild Speichern